import React from "react";

const SOURCE_SHA_PATTERN = /^[0-9a-f]{40}$/;
const ARTIFACT_SHA_PATTERN = /^[0-9a-f]{64}$/;

function isPlatformAdmin(user) {
  return (user?.roles || [])
    .some((role) => String(role).toUpperCase() === "PLATFORM_ADMIN");
}

export default function DeploymentStamp({ user, identity }) {
  if (!isPlatformAdmin(user)) return null;

  const verified = identity?.status === "VERIFIED";
  const version = typeof identity?.version === "string" ? identity.version : "unknown";
  const sourceCommit = typeof identity?.source_commit === "string"
    && SOURCE_SHA_PATTERN.test(identity.source_commit)
    ? identity.source_commit
    : "unknown";
  const artifactDigest = typeof identity?.artifact_sha256 === "string"
    && ARTIFACT_SHA_PATTERN.test(identity.artifact_sha256)
    ? identity.artifact_sha256
    : "unknown";
  const unavailable = !identity || identity.status === "UNAVAILABLE";
  const summary = verified
    ? `${version} · ${sourceCommit.slice(0, 7)}`
    : `${version} · ${unavailable ? "unavailable" : "unverified"}`;

  return (
    <details className="deployment-stamp">
      <summary aria-label={`Deployment identity: ${summary}`}>
        <span>Deployment</span>
        <strong>{summary}</strong>
      </summary>
      <dl>
        <dt>Status</dt>
        <dd>{verified ? "Verified" : unavailable ? "Unavailable" : "Unverified"}</dd>
        <dt>HACaMS version</dt>
        <dd>{version}</dd>
        <dt>Source commit</dt>
        <dd>{sourceCommit}</dd>
        <dt>Build timestamp</dt>
        <dd>{identity?.build_timestamp || "unknown"}</dd>
        <dt>UI artifact SHA-256</dt>
        <dd>{artifactDigest}</dd>
      </dl>
    </details>
  );
}
